module.exports = __webpack_public_path__ + "static/noticias-06-e7e3de0a65f9abc039f75060a7218e6c.jpg";